import { useMemo } from 'react';

import {
  makeFullHeadMprSliceGroups,
  type ToothBasisSeriesName,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import {
  DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES,
  TOOTH_BASIS_SERIES_TO_GROUP,
  type FullHeadMprSliceGroupView,
  type ToothBasisSeriesFrames,
  type ToothBasisSeriesView,
  type ToothSliceOptionsBySeries,
} from '../config';

export const useFullHeadMprSliceGroups = ({
  frames,
  pendingSeries,
  series,
  slabThicknessMm,
  sliceOptions = DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES,
  sliceStepMm,
  toothID,
}: {
  frames: ToothBasisSeriesFrames | null;
  series: ToothBasisSeriesView | null;
  slabThicknessMm: Record<ToothBasisSeriesName, number> | null;
  sliceStepMm: Record<ToothBasisSeriesName, number> | null;
  toothID: string;
  pendingSeries?: ToothBasisSeriesName[];
  sliceOptions?: ToothSliceOptionsBySeries;
}): FullHeadMprSliceGroupView[] =>
  useMemo(
    () =>
      makeFullHeadMprSliceGroups({
        frames,
        pendingSeries,
        series,
        slabThicknessMm,
        sliceOptions: {
          axial: {
            sliceStepMm: sliceOptions.axial.sliceStepMm,
            thicknessMm: sliceOptions.axial.thicknessMm,
          },
          sagittal: {
            sliceStepMm: sliceOptions.sagittal.sliceStepMm,
            thicknessMm: sliceOptions.sagittal.thicknessMm,
          },
          frontal: {
            sliceStepMm: sliceOptions.frontal.sliceStepMm,
            thicknessMm: sliceOptions.frontal.thicknessMm,
          },
        },
        sliceStepMm,
        toothID,
      }).map((group) => ({
        ...group,
        groupName: TOOTH_BASIS_SERIES_TO_GROUP[group.seriesName],
      })),
    [
      frames,
      pendingSeries,
      series,
      slabThicknessMm,
      sliceOptions.axial.sliceStepMm,
      sliceOptions.axial.thicknessMm,
      sliceOptions.sagittal.sliceStepMm,
      sliceOptions.sagittal.thicknessMm,
      sliceOptions.frontal.sliceStepMm,
      sliceOptions.frontal.thicknessMm,
      sliceStepMm,
      toothID,
    ],
  );
